// ================================================================
//  ApiCollectionViewer
//  Opens the Collection Details dialog (and, from it, the Edit dialog)
//  for a single collection version, from anywhere in the app — the
//  API Collections list, the template explorer, the template editor.
// ================================================================

angular.module('bizmetryApp').factory('ApiCollectionViewer', function (
    $mdDialog,
    ApiCollectionService,
    dialogService
) {

    // PUBLISHED is editable too: saving forks a new DRAFT version (see Edit dialog).
    function isEditable(status) {
        return status !== 'RETIRED';
    }

    function _sessionInfo() {
        try { return JSON.parse(sessionStorage.getItem('user') || '{}'); } catch (e) { return {}; }
    }

    function _showLoadError(err, collectionId, message) {
        dialogService.showErrorDialog(
            'Failed to Load Collection',
            dialogService.formatErrorMessage({
                error:     (err.data && err.data.error)     || 'Fetch Error',
                message:   (err.data && err.data.message)   || message,
                path:      (err.data && err.data.path)      || '/v1/api/bizmetry/api-collection/' + collectionId,
                timestamp: (err.data && err.data.timestamp) || new Date().toISOString()
            })
        );
    }

    // Resolves with the Edit dialog result ({ updated, collection } | { forked, collection }),
    // or null when it is cancelled.
    function _showEdit(fullCollection, sessionInfo) {
        return $mdDialog.show({
            controller:          'ApiCollectionEditDialogController',
            controllerAs:        'ctrl',
            templateUrl:         'home/main-menu/api-collection/edit-collection/edit-api-collection-dialog.html',
            parent:               angular.element(document.body),
            clickOutsideToClose: false,
            escapeToClose:       true,
            fullscreen:          false,
            multiple:            true,
            locals: {
                sessionInfo: sessionInfo || _sessionInfo(),
                collection:  fullCollection
            }
        }).catch(function () { return null; });
    }

    function edit(collectionId, sessionInfo) {
        return ApiCollectionService.getById(collectionId)
            .then(function (fullCollection) { return _showEdit(fullCollection, sessionInfo); })
            .catch(function (err) {
                _showLoadError(err, collectionId, 'Could not load the collection. Please try again.');
                return null;
            });
    }

    // options.allowEdit: the dialog offers "Edit" (non-RETIRED versions only).
    // Resolves with the Edit dialog result when the collection was edited from
    // the details dialog, null otherwise.
    function openDetails(collectionId, options) {
        options = options || {};
        return ApiCollectionService.getById(collectionId)
            .then(function (fullCollection) {
                return $mdDialog.show({
                    controller:          'ApiCollectionDetailDialogController',
                    controllerAs:        'ctrl',
                    templateUrl:         'home/main-menu/api-collection/details/api-collection-details-dialog.html',
                    parent:               angular.element(document.body),
                    clickOutsideToClose: true,
                    escapeToClose:       true,
                    fullscreen:          false,
                    multiple:            true,
                    locals: {
                        collection: fullCollection,
                        canEdit:    !!options.allowEdit && isEditable(fullCollection.status)
                    }
                }).then(function (result) {
                    return result && result.edit ? _showEdit(fullCollection, options.sessionInfo) : null;
                }, function () { return null; });
            })
            .catch(function (err) {
                _showLoadError(err, collectionId, 'Could not load the collection details. Please try again.');
                return null;
            });
    }

    return {
        isEditable:  isEditable,
        edit:        edit,
        openDetails: openDetails
    };
});
